module.exports = __webpack_public_path__ + "static/img/microchip_256.47938bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/microchip_256.png
// module id = 8VI9
// module chunks = 0